import React, { useEffect, useState } from "react";

const COOKIE_KEY = "almoune_cookie_consent";

const getStoredConsent = () => {
  try {
    return window.localStorage.getItem(COOKIE_KEY);
  } catch {
    return null;
  }
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getStoredConsent();
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const setConsent = (value) => {
    try {
      window.localStorage.setItem(COOKIE_KEY, value);
    } catch { /* ignore */ }
    setVisible(false);
  };

  const handleDecline = () => setConsent("declined");
  const handleAcceptAll = () => setConsent("accepted");

  return (
    <div className={`gw-cookie-consent ${visible ? "gw-cookie-visible" : ""}`} role="dialog" aria-label="Consentement aux cookies">
      <div className="gw-cookie-inner">
        <div className="gw-cookie-icon" aria-hidden="true">🍪</div>
        <div className="gw-cookie-text">
          <p className="gw-cookie-title">Nous respectons votre vie privee</p>
          <p className="gw-cookie-desc">
            Nous utilisons des cookies pour ameliorer votre navigation, analyser le trafic et personnaliser
            nos offres. Vous pouvez choisir d'accepter ou de les refuser a tout moment.
          </p>
        </div>
        <div className="gw-cookie-actions">
          <button type="button" className="gw-cookie-btn gw-cookie-accept" onClick={handleAcceptAll}>Tout accepter</button>
          <button type="button" className="gw-cookie-btn gw-cookie-deny" onClick={handleDecline}>Refuser</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
